import { render, staticRenderFns } from "./RegionListTable.vue?vue&type=template&id=49f915ca"
import script from "./RegionListTable.vue?vue&type=script&lang=js"
export * from "./RegionListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports